var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.511906 13.4306C0.197412 13.7001 0.160991 14.1736 0.430558 14.4881C0.700124 14.8026 1.1736 14.839 1.48809 14.5694L0.511906 13.4306ZM15.7478 2.05752C15.7796 1.64453 15.4705 1.28398 15.0575 1.25221L8.3274 0.734508C7.91441 0.702739 7.55386 1.01178 7.52209 1.42478C7.49032 1.83777 7.79937 2.19832 8.21236 2.23009L14.1947 2.69027L13.7345 8.6726C13.7027 9.08559 14.0118 9.44614 14.4248 9.47791C14.8378 9.50968 15.1983 9.20063 15.2301 8.78764L15.7478 2.05752ZM1.48809 14.5694L15.4881 2.56944L14.5119 1.43056L0.511906 13.4306L1.48809 14.5694Z",
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightArrow);
export default __webpack_public_path__ + "static/media/TopRightArrow.a100ea57b10644a6323cb7d2b3458a67.svg";
export { ForwardRef as ReactComponent };